module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czcg-box"
  }, [_c('div', {
    staticClass: "czcg-content"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "czcg-title"
  }, [_vm._v(_vm._s(_vm.$t('all.chongbichenggong')))]), _vm._v(" "), _c('div', {
    staticClass: "czcg-info"
  }, [_c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.bizhong')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("NB")])]), _vm._v(" "), _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("+1000.00")])]), _vm._v(" "), _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("NB Chain")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijian')))]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value"
  }, [_vm._v("2026/06/10 13:20")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czcg-icon"
  }, [_c('img', {
    staticClass: "czcg-icon-check",
    attrs: {
      "src": require("../../../assets/image/tijiaoshengqing_134@2x.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czcg-info-item"
  }, [_c('span', {
    staticClass: "czcg-info-label"
  }, [_vm._v("TxHash")]), _vm._v(" "), _c('span', {
    staticClass: "czcg-info-value czcg-text-green"
  }, [_vm._v("0x82...8F91")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3e3964"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/chongzhichenggong/chongzhichenggong.vue
// module id = 1025
// module chunks = 1